/**
 * dom_json: utilities for transporting JSON via HTML
 */


/**
 * decodeDomJson
 * decodes a string of HTML-encoded JSON, replacing html entities
 * and parsing the result as JSON
 * @param  {string} dom_text HTML-encoded JSON
 * @return {json} json resulting JSON data
 */
function decodeDomJson(dom_text) {
    const text = (
        dom_text
        // decode < > first
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
        // then decode ampersands to restore any previously html-encoded strings
            .replace(/&amp;/g, '&')
    )
    const json = JSON.parse(text)

    return json
}


/**
 * encodeDomJson
 * encodes a JSON object into an HTML-ready string
 * @param  {json} json a JSON object
 * @return {string} text HTML-ready string of JSON data
 */
function encodeDomJson(json) {
    const text = (
        JSON.stringify(json)
        // encode ampersands first, so existing html-encoded strings don't get
        // decoded prematurely
            .replace(/&/g, '&amp;')
        // encode < > to neuter any XSS vectors in our JSON data
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
    )

    return text
}


/**
* getJsonFromDomNode
* consumes the text of a DOM node, parses it as JSON, and returns a JSON object
* @param {string} selector: a DOM selector specifying the node to be consumed
* @param {object} default_json (optional): a default JSON object to be returned if DOM JSON is not found
* @return {object} dictionary of keys and values
*/

function getJsonFromDomNode(selector, default_json) {

    let json

    try {
        const node = document.querySelector(selector)
        let text

        if (! node) {
            throw new Error(`getJsonFromDomNode: node not found: ${selector}`)
        }

        try {
            text = node.textContent.trim()
        } catch {
            throw new Error('getJsonFromDomNode: could not access node.textContent')
        }

        if (! text) {
            throw new Error('getJsonFromDomNode: node is empty')
        }

        try {
            json = decodeDomJson(text)
        } catch {
            throw new Error('getJsonFromDomNode: parse failed')
        }
    } catch (e) {
        if (typeof default_json === 'object') {
            json = default_json
        } else {
            throw e
        }
    }

    return json

}

module.exports = {
    getJsonFromDomNode,
    decodeDomJson,
    encodeDomJson,
}
